import { ExtendedProjectPhase } from '@bpd-library/utilities';

import { FormattedStatus, StatusTranslations } from '.';

/**
 * @description Returns the translated project phase status and color
 * @param {ExtendedProjectPhase} projectPhase
 * @return {*}  {(FormattedStatus | undefined)}
 */
const formatProjectPhaseStatus = (
    projectPhase: ExtendedProjectPhase,
): FormattedStatus | undefined => {
    const { status } = projectPhase;

    if (!status || status === 'NotActive') return;

    return StatusTranslations.FORMATTED[status];
};

export { formatProjectPhaseStatus };
